import React, { useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";

const Careercs2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const sections = [
    {
      title: "Internships",
      description: `With Tech Informatic Solutions internship, you'll get valuable hands-on experience, mentoring and practical training in a work environment related to your field of study.\n\nYou'll see at first-hand how we deal with real-life business challenges across our value chain, gaining insights that will give you a head start in your career.\n\nInternships last from one to six months depending on the project.\n\nAvailability: Global`,
      image: "/image/paint.png",
      reverse: false,
    },
    {
      title: "Tech Informatic Solutions needs YOUTH",
      description: `If we can nurture the talent, energy and dreams of young people around the world, we can help ensure a sustainable future for everyone.\n\nThat’s why we’ve created theTech Informatic Solutions needs Youth program. Designed to equip young people with the skills they need to thrive in tomorrow’s workplaces, it has three focus areas:\n\n1) Helping young people to find work and build their skills for employment\n2) Supporting young entrepreneurs to kickstart and grow businesses\n3) Supporting young people to make a decent living out of agriculture.\n\nAvailability: Global`,
      image: "/image/careercase2img2.jpg",
      reverse: true,
    },
  ];

  return (
    <Box >
      {/* Hero Section - Reduced height */}
      <Box
        sx={{
            height: "100vh",
          backgroundImage: `url('/image/careercs2.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: "96px" }, // 1 inch padding
        }}
      >
        <Box maxWidth="1200px">
          <Typography
            variant="h1"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: "50px", md: "60px" },
            }}
          >
            Students and graduates
          </Typography>
        </Box>
      </Box>

      {/* Main Content Section with consistent 1-inch side padding */}
      <Box
        sx={{
          width: "100%",
          py: 6,
          px: { xs: 2, sm: 3, md: "96px" },
         // backgroundColor: "#f5f5f5",
          backgroundColor:"#C4D8E2",
          boxSizing: "border-box",
        }}
      >
        <Typography variant="h3" fontWeight="bold" mb={6}>
          Opportunities for development
        </Typography>

        <Typography
          variant="body1"
          sx={{ fontSize: "18px", color: "#444", mb: 8 }}
        >
          We think like innovators. Embrace diversity. Work in an agile way. And,
          we also have the scale to make a positive difference to people’s lives.
          So, if you want your work to make an impact, Tech Informatic Solutions offers inspiring
          early-career opportunities worldwide.
        </Typography>

        <Typography variant="h3" mb={3}>
          Key programs
        </Typography>

        {sections.map((section, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: isMobile
                ? "column"
                : section.reverse
                ? "row-reverse"
                : "row",
              alignItems: "center",
              gap: 4,
              mb: 6,
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            {/* Image */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
              }}
            >
              <img
                src={section.image}
                alt={section.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "12px",
                }}
              />
            </Box>

            {/* Text Content */}
            <Box
              sx={{
                flex: 1,
                padding: isMobile ? 2 : 3,
                textAlign: isMobile ? "center" : "left",
              }}
            >
              <Typography
                variant="h5"
                sx={{ mb: 4, fontSize: isMobile ? 26 : 34 }}
              >
                {section.title}
              </Typography>
              {section.description.split("\n").map((line, i) => (
                <Typography
                  key={i}
                  variant="body1"
                  sx={{ mb: 1.5, color: "#444", fontSize: 18 }}
                >
                  {line}
                </Typography>
              ))}
            </Box>
          </Box>
        ))}
      </Box>

      <Footer />
    </Box>
  );
};

export default Careercs2;
